var map = {
	"./CannaProvisions": 9949,
	"./CannaProvisions.tsx": 9949,
	"./Default": 62407,
	"./Default.tsx": 62407,
	"./Hyperwolf": 28434,
	"./Hyperwolf.tsx": 28434,
	"./RoyalRain": 55763,
	"./RoyalRain.tsx": 55763,
	"./Standard": 35113,
	"./Standard.tsx": 35113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77362;